import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { INotiCase } from "./SunsetAlimtalk";
import SunsetAlimtalkCaseBtn from "./SunsetAlimtalkCaseBtn";

interface SunsetAlimtalkCaseProps {
  notiCase: INotiCase;
  notiCaseSave: INotiCase;
  setNotiCase: Dispatch<SetStateAction<INotiCase>>;
  sunsetType: number;
}

export default function SunsetAlimtalkCase({
  notiCaseSave,
  notiCase,
  setNotiCase,
  sunsetType,
}: SunsetAlimtalkCaseProps) {
  console.log(notiCaseSave);
  console.log(notiCase);

  const allFalse =
    sunsetType === 1 // opt-in
      ? {
          matchingWaiting: false,
          before: false,
          underMonth: false,
          overMonthOwner: false,
          overMonthMember: false,
          invAcceptMember: false,
        }
      : {
          matchingWaiting: false,
          before: false,
          underMonth: false,
          overMonthOwner: false,
          overMonthMember: false,
        };

  return (
    <SunsetAlimtalkCaseContainer>
      <SunsetAlimtalkCaseBtn
        btnText="매칭 대기"
        state={
          notiCaseSave?.matchingWaiting
            ? "success"
            : notiCase?.matchingWaiting
            ? "active"
            : "notSelected"
        }
        btnClickEvent={() => {
          setNotiCase({
            ...allFalse,
            matchingWaiting: true,
          });
        }}
      />

      <SunsetAlimtalkCaseBtn
        btnText="예정"
        state={
          notiCaseSave?.before
            ? "success"
            : notiCase?.before
            ? "active"
            : "notSelected"
        }
        btnClickEvent={() => {
          setNotiCase({
            ...allFalse,
            before: true,
          });
        }}
      />

      <SunsetAlimtalkCaseBtn
        btnText="파티 종료<한달"
        state={
          notiCaseSave?.underMonth
            ? "success"
            : notiCase?.underMonth
            ? "active"
            : "notSelected"
        }
        btnClickEvent={() => {
          setNotiCase({
            ...allFalse,
            underMonth: true,
          });
        }}
      />

      <SunsetAlimtalkCaseBtn
        btnText="파티 종료>한 달_파티장"
        state={
          notiCaseSave?.overMonthOwner
            ? "success"
            : notiCase?.overMonthOwner
            ? "active"
            : "notSelected"
        }
        btnClickEvent={() => {
          setNotiCase({
            ...allFalse,
            overMonthOwner: true,
          });
        }}
      />

      <SunsetAlimtalkCaseBtn
        btnText="파티 종료>한 달_파티원"
        state={
          notiCaseSave?.overMonthMember
            ? "success"
            : notiCase?.overMonthMember
            ? "active"
            : "notSelected"
        }
        btnClickEvent={() => {
          setNotiCase({
            ...allFalse,
            overMonthMember: true,
          });
        }}
      />

      {/* opt-in 인 경우만 값이 있음 */}
      {sunsetType === 1 && (
        <SunsetAlimtalkCaseBtn
          btnText="초대 수락_파티원"
          state={
            notiCaseSave?.invAcceptMember
              ? "success"
              : notiCase?.invAcceptMember
              ? "active"
              : "notSelected"
          }
          btnClickEvent={() => {
            setNotiCase({
              ...allFalse,
              invAcceptMember: true,
            });
          }}
        />
      )}
    </SunsetAlimtalkCaseContainer>
  );
}

const SunsetAlimtalkCaseContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 8px;
`;
